export const STEPS = {
  info: 'Informacion',
  delivery: 'Envio',
  pay: 'Pago',
};

export const KEYS = Object.keys(STEPS);
export const VALUES = Object.values(STEPS);
